<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType === 'contract_id' }"
                        @click="sortCall('contract_id')"
                      >
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="!sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortReverse"
                        ></span>
                         ID Contrato
                      </td>
                      <td nowrap class="text-center align-middle" >ID Cliente</td>
                      <td nowrap class="text-center align-middle" >Alterado por</td>
                      <td nowrap class="text-center align-middle" >Ação</td>
                      <td nowrap class="text-center align-middle" >Data alteração</td>
                      <td nowrap class="text-center align-middle" >Campo alterado</td>
                      <td class="text-center align-middle" >Valor antigo</td>
                      <td class="text-center align-middle" >Valor novo</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          v-model="filters.contract_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          v-model="filters.customer_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.changed_by"
                        />

                      </td>
                      <td>
                          <SelectAuditsEvent
                            :first="'Todos'"
                            @change="setFilter('audit_event', $event)"
                            :selected="filters.audit_event"
                            class="form-control-sm"
                          />
                      </td>
                      <td>
                        <input
                          id="change_date"
                          type="date"
                          ref="change_date"
                          class="form-control form-control-sm col-md-11"
                          v-model="filters.change_date"
                          value="1"
                          v-b-tooltip.hover
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(audit, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ audit.contract_id }}</td>
                      <td class="text-center align-middle">{{ audit.customer_id }}</td>
                      <td nowrap class="text-center align-middle">{{ audit.user_name }}</td>
                      <td class="text-center align-middle">{{ audit.event | audit_event }}</td>
                      <td class="text-center align-middle">{{ audit.created_at | date }}</td>
                      <td nowrap class="text-center align-left">{{ audit.type }}</td>
                      <td class="text-left align-left">{{ formatData(audit.old_values) }}</td>
                      <td class="text-left align-left">{{ formatData(audit.new_values) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">{{
                        data.current_page - 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">{{
                        data.current_page - 1
                      }}</a>
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">{{
                        data.current_page + 1
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">{{
                        data.current_page + 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page">
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin';
import SelectAuditsEvent from '@/components/forms/SelectAuditsEvent';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'ReportContractsChange',
  alert:{
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
  },
  components: { SelectAuditsEvent },
  data() {
    return {
      sortType: localStorage.customerContractsChangeSortType
        ? localStorage.customerContractsChangeSortType
        : 'contract_id',
      sortReverse: localStorage.customerContractsChangeSortReverse
        ? JSON.parse(localStorage.customerContractsChangeSortReverse)
        : false,
      amount: localStorage.customerContractsChangeAmount
        ? localStorage.customerContractsChangeAmount
        : 100,
      page: localStorage.customerContractsChangePage 
        ? localStorage.customerContractsChangePage 
        : 1,
      filters: {
        contract_id: localStorage.customerContractsChangeFilterContractId 
          ? localStorage.customerContractsChangeFilterContractId 
          : '',
        customer_id: localStorage.customerContractsChangeFilterCustomerID
          ? localStorage.customerContractsChangeFilterCustomerID
          : '',
        changed_by: localStorage.customerContractsChangeFilterChangedBy
          ? localStorage.customerContractsChangeFilterChangedBy
          : '',
        change_date: localStorage.customerContractsChangeFilterChangeData
          ? localStorage.customerContractsChangeFilterChangeData
          : '',
        audit_event: localStorage.customerContractsChangeFilterAuditEvent
          ? localStorage.customerContractsChangeFilterAuditEvent
          : '',
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/audits/contracts-change/download/${this.convertFilters()}`;
      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
              ...arrData.map((item) => {
                item['Ação'] = (item['Ação'] == 'created' 
                                  ? 'Criado' 
                                  : (
                                      item['Ação'] == 'updated' 
                                      ? 'Alterado' 
                                      : 'Excluído'
                                    )
                                );
                item['Data alteração'] = item['Data alteração'].substring(0,10).split('-').reverse().join('/');
                item['Valor antigo'] = this.formatData(item['Valor antigo']);
                item['Valor novo'] = this.formatData(item['Valor novo']);
                return String(Object.values(item).join(';'));
            }),
          ]
          .join('\n')
          .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_alteracoes_contrato`;

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);
          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.contract_id = '';
      this.filters.customer_id = '';
      this.filters.changed_by = '';
      this.filters.change_date = '';
      this.filters.audit_event = '';

      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerContractsChangeFilterContractId', this.filters.contract_id);
      localStorage.setItem('customerContractsChangeFilterCustomertId', this.filters.customer_id);
      localStorage.setItem('customerContractsChangeFilterChangedBy', this.filters.changed_by);
      localStorage.setItem('customerContractsChangeFilterChangeData', this.filters.change_date);
      localStorage.setItem('customerContractsChangeFilterAuditEvent', this.filters.audit_event);
      localStorage.setItem('customerContractsChangeAmount', this.amount);
      localStorage.setItem('customerContractsChangePage', this.page);
      localStorage.setItem('customerContractsChangeSortType', this.sortType);
      localStorage.setItem('customerContractsChangeSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}
                        &amount=${this.amount}
                        &changed_by=${this.filters.changed_by}
                        &change_date=${this.filters.change_date}
                        &audit_event=${this.filters.audit_event}
                        &sortType=${this.sortType}
                        &sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
                        &contract_id=${this.filters.contract_id}
                        &customer_id=${this.filters.customer_id}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/contracts-change/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
           this.page = 1;
        }
      })
      .catch((error) => {
          this.logMessageFailed(error.response);
      });
    },
    formatData(data){ 
      let tratedData = this.displayFields(data);
      const dataNew = Object.entries(tratedData);
      tratedData = '';

      dataNew.forEach(item => {
        if(item[0] == 'datas'){
          if(item[1] != null ){
            tratedData += this.getValue(item[1], item[0])+", ";
          }
          return;
        } 
        tratedData += this.getFieldLabel(item[0])+": "+this.getValue(item[1], item[0])+", ";
      });      
      return tratedData.substring(0, tratedData.length - 2);
    },
    getFieldLabel(index) {
      const defaultFields = {
        product_id: 'Produto',
        customer_id: 'Cliente',
        plan_id: 'Plano',
        finish: 'Fim do contrato',
        start: 'Início do contrato',
        note: 'Observações',
        billing_method: 'Cobrar por',
        due_day: 'Dia vencimento',
        contract_type: 'Tipo contrato',
        due_in_days: 'Prazo de vencimento',
        price: 'Preço',
        amount: 'Quantidade',
        datas: 'Faixas, Valor mínimo, etc',
        change_reason: 'Motivo da alteração',
        hired_by: 'Contratado por',
        grace_date: 'Data de carência',
        note_chatbot: 'Informações chatbot',
        status: 'Status',
        plan_type_id: 'Plano',
      };

      return defaultFields[index];
    },
    getValue(value, index) {
      if (
        typeof value !== 'undefined' &&
        value != '0000-00-00' &&
        (index == 'finish' || index == 'start' || index == 'grace_date')
      ) {
        return value ? this.$options.filters.date(value) : '-';
      }

      if (typeof value !== 'undefined' && index == 'price') {
        return this.$options.filters.money(value ? value : 0);
      }

      if (typeof value !== 'undefined' && index == 'contract_type') {
        return value == 1 ? 'Legado' : value == 2 ? 'TC' : 'PME';
      }

      if (typeof value !== 'undefined' && index == 'billing_method') {
        return value == 1 ? 'Carteira' : 'CNPJ';
      }

      if (typeof value !== 'undefined' && index == 'hired_by') {
        return value == 1 ? 'Termo' : 'Contrato';
      }

      if (typeof value !== 'undefined' && index == 'change_reason') {
        // Caso change reason for igual ao anterior
        return (value = value.replace('⠀', ''));
      }

      if (value && index == 'datas') {
        value = value.replace('"billing_type":0,', '');
        value = value.replace('"billing_type":1', ' Faixa Simples');
        value = value.replace('"billing_type":2', ' Faixa Acumulada');
        value = value.replace('"billing_type":3', ' Faixa Modular');
        value = value.replace('"billing_type":4', ' Faixa Modular Mista');
        value = value.replace('"billing_type": 1', ' Faixa Simples');
        value = value.replace('"billing_type": 2', ' Faixa Acumulada');
        value = value.replace('"billing_type": 3', ' Faixa Modular');
        value = value.replace('"billing_type": 4', ' Faixa Modular Mista');
        value = value.replace('"charge_use_only":1', ' Cobrar todos usuários');
        value = value.replace('"charge_use_only":0', ' Cobrar apenas usuários utilizados');
        value = value.replace('"charge_use_only": 0', ' Cobrar apenas usuários utilizados');
        value = value.replace('"minimal":', ' Valor mínimo: ');
        value = value.replace('"extra":', ' Valor extra: ');
        value = value.replace('"fixed":', ' Valor fixo: ');
        value = value.replace('"hired_by":0', ' Contrato');
        value = value.replace('"hired_by":1', ' Termo');
        value = value.replace('"contact_recep_total":', ' Contato Receptivo: ');
        value = value.replace('"receptive_excess":', ' Receptivos por excedentes: ');
        value = value.replace('"licenses_included":', ' Licenças inclusas: ');
        value = value.replace('"quantity_enterprise_session_active":', ' Quantidade Sessões Ativas: ');
        value = value.replace('"enterprise_session_active":', ' Valor Sessões Ativas: ');
        value = value.replace('"quantity_enterprise_session_receptive":', ' Quantidade Sessões Receptivas: ');
        value = value.replace('"enterprise_session_receptive":', ' Valor Sessões Receptivas: ');
        value = value.replace('"enterprise_use_facebook_bonus":'," Aplicar bônus cedido pelo facebook: ");
        value = value.replace('"enterprise_use_facebook_prices":'," Usar valores do facebook (convertido no valor do dólar atual): ");
        value = value.replaceAll('{','');
        value = value.replaceAll('}','');
        value = value.replaceAll('""', '0');
        value = value.replaceAll('null', '0');
        value = value.replaceAll('true', 'sim');
        value = value.replaceAll('false', 'não');
      }

      if (index == 'status') {
        switch (value.toString()) {
          case '2':
            return 'Ativo';
          case '1':
            return 'Bloqueado';
          case '0':
            return 'Suspenso';
          default:
        }
      }

      if (index == 'plan_type_id') {
        switch (value.toString()) {
          case '1':
            return 'Light';
          case '2':
            return 'Básico';
          case '3':
            return 'Intermediário';
          case '4':
            return 'Avançado';
          case '5':
            return 'Grandes Contas';
          case '6':
            return 'Outro';
          default:
        }
      }

      return value || 0;
    },
    displayFields(values) {
      let list = [];
      const filterFields = ['contract_id', 'type_id', 'id', 'service_id'];
      list = values;

      for (const [key, value] of Object.entries(list)) {
        if (filterFields.includes(key)) {
          delete list[key];
        }
      }
      return list;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
